@if (infoForm) {
<form nz-form [formGroup]="infoForm" class="ppl-p0">
  @if(sectionName === 'employer') {
  <nz-row>
    @if(isAttrAvailable('taskManager')){
    <div nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSpan]="24"
          [nzFor]="getAccessibleInputId('taskManager')"
          class="ppl-form-label">{{getAttributes('taskManager').label}}
          @if(!formReadonly && getAttributes('taskManager').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control [nzSpan]="24" class="ppl-form-control">
          <div nz-tooltip
            [nzTooltipTitle]="getAttributes('taskManager')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <div class="ppl-select"
              [ngClass]="{'error': validationErrors['taskManager'] }">
              <ppl-dropdown-select formControlName="taskManager"
                id="{{getAccessibleInputId('taskManager')}}"
                placeholder="{{getAttributes('taskManager').placeholder}}"
                aria-required="true"
                aria-describedby="taskManagerError"
                [attr.aria-invalid]="validationErrors['taskManager'] ? 'true' : 'false'"
                [options]="taskManagerOptions"
                [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                [disabled]="formReadonly && isReadonly()"
                (selectionChange)="onTrackingManagerChange($event)">
              </ppl-dropdown-select>
            </div>
          </div>
          @if (validationErrors['taskManager']) {
          <span
            class="pl-1 error-message">{{validationErrors['taskManager']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </div>
    }
  </nz-row>
  }

  @if((sectionName !== 'employer' && !isAttrAvailable('taskManager')) ||
  (sectionName === 'employer' && isAttrAvailable('taskManager') &&
  infoForm.get('taskManager')?.value !== null)) {
  <nz-row>
    @if(isAttrAvailable('legalName')){
    <nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSpan]="24" nzFor="legalName"
          class="ppl-form-label">{{getAttributes('legalName').label}}
          @if(getAttributes('legalName').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control [nzSpan]="24" class="ppl-form-control">
          <div nz-tooltip
            [nzTooltipTitle]="getAttributes('legalName')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <input nz-input formControlName="legalName" autocomplete="off"
              [id]="'legalName' + sectionName"
              placeholder="{{getAttributes('legalName').placeholder}}"
              [ngClass]="{'error': validationErrors['legalName'] }"
              [readonly]="formReadonly || (isReadonly() && getFormControlValue('legalName'))" />
          </div>
          @if (validationErrors['legalName']) {
          <span
            class="pl-1 error-message">{{validationErrors['legalName']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    }
    @if(isAttrAvailable('businessName')){
    <nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSpan]="24" nzFor="businessName"
          class="ppl-form-label">{{getAttributes('businessName').label}}
          @if(getAttributes('businessName').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control [nzSpan]="24" class="ppl-form-control">
          <div nz-tooltip
            [nzTooltipTitle]="getAttributes('businessName')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <input nz-input formControlName="businessName"
              [id]="'businessName' + sectionName"
              placeholder="{{getAttributes('businessName').placeholder}}"
              [ngClass]="{'error': validationErrors['businessName'] }"
              [readonly]="formReadonly || (isReadonly() && getFormControlValue('businessName'))" />
          </div>
          @if (validationErrors['businessName']) {
          <span
            class="pl-1 error-message">{{validationErrors['businessName']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    }

    @if(isAttrAvailable('vendorName')){
    <nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSpan]="24" nzFor="vendorName"
          class="ppl-form-label">{{getAttributes('vendorName').label}}
          @if(getAttributes('vendorName').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control [nzSpan]="24" class="ppl-form-control">
          <div nz-tooltip
            [nzTooltipTitle]="getAttributes('vendorName')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <input nz-input formControlName="vendorName"
              [id]="'vendorName' + sectionName"
              placeholder="{{getAttributes('vendorName').placeholder}}"
              [ngClass]="{'error': validationErrors['vendorName'] }"
              [readonly]="formReadonly" />
          </div>
          @if (validationErrors['vendorName']) {
          <span
            class="pl-1 error-message">{{validationErrors['vendorName']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    }
    @if(isAttrAvailable('doingBusinessAs')){
    <div nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSpan]="24" nzFor="doingBusiness"
          class="ppl-form-label">{{getAttributes('doingBusinessAs').label}}
          @if(getAttributes('doingBusinessAs').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control [nzSpan]="24" class="ppl-form-control">
          <div nz-tooltip
            [nzTooltipTitle]="getAttributes('doingBusinessAs')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <input nz-input formControlName="dbaName" id="doingBusiness"
              placeholder="{{getAttributes('doingBusinessAs').placeholder}}"
              [ngClass]="{'error': validationErrors['doingBusinessAs'] }"
              [readonly]="formReadonly" />
          </div>
          @if (validationErrors['doingBusinessAs']) {
          <span
            class="pl-1 error-message">{{validationErrors['doingBusinessAs']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </div>
    }
    @if(isAttrAvailable('fname')){
    <nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSpan]="24" nzFor="firstName"
          class="ppl-form-label">{{getAttributes('fname').label}}
          @if(getAttributes('fname').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control [nzSpan]="24" class="ppl-form-control">
          <div nz-tooltip
            [nzTooltipTitle]="getAttributes('fname')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <input nz-input formControlName="fname" [id]="'fname' + sectionName"
              placeholder="{{getAttributes('fname').placeholder}}"
              [ngClass]="{'error': validationErrors['fname'] }"
              [readonly]="formReadonly || (isReadonly() && getFormControlValue('fname'))" />
          </div>
          @if (validationErrors['fname']) {
          <span class="pl-1 error-message">{{validationErrors['fname']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    }

    @if(isAttrAvailable('mname')){
    <nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSpan]="24" nzFor="mname"
          class="ppl-form-label">{{getAttributes('mname').label}}
          @if(getAttributes('mname').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control [nzSpan]="24" class="ppl-form-control">
          <div nz-tooltip
            [nzTooltipTitle]="getAttributes('mname')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <input nz-input formControlName="mname" [id]="'mname' + sectionName"
              placeholder="{{getAttributes('mname').placeholder}}"
              [ngClass]="{'error': validationErrors['mname'] }"
              [readonly]="formReadonly || isReadonly()" />
          </div>
          @if (validationErrors['mname']) {
          <span class="pl-1 error-message">{{validationErrors['mname']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    }

    @if(isAttrAvailable('lname')){
    <nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSpan]="24" nzFor="lastName"
          class="ppl-form-label">{{getAttributes('lname').label}}
          @if(getAttributes('lname').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control [nzSpan]="24" class="ppl-form-control">
          <div nz-tooltip
            [nzTooltipTitle]="getAttributes('lname')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <input nz-input formControlName="lname" [id]="'lname' + sectionName"
              placeholder="{{getAttributes('lname').placeholder}}"
              [ngClass]="{'error': validationErrors['lname'] }"
              [readonly]="formReadonly || (isReadonly() && getFormControlValue('lname'))" />
          </div>
          @if (validationErrors['lname']) {
          <span class="pl-1 error-message">{{validationErrors['lname']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    }

    @if(isAttrAvailable('maiden_name')){
    <div nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSpan]="24" nzFor="maiden_name"
          class="ppl-form-label">{{getAttributes('maiden_name').label}}
          @if(getAttributes('maiden_name').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control [nzSpan]="24" class="ppl-form-control">
          <div nz-tooltip
            [nzTooltipTitle]="getAttributes('maiden_name')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <input nz-input formControlName="maiden_name"
              [id]="'maiden_name' + sectionName"
              placeholder="{{getAttributes('maiden_name').placeholder}}"
              [ngClass]="{'error': validationErrors['maiden_name'] }"
              [readonly]="formReadonly" />
          </div>
          @if (validationErrors['maiden_name']) {
          <span
            class="pl-1 error-message">{{validationErrors['maiden_name']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </div>
    }

    @if(isAttrAvailable('dob')){
    <div nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSpan]="24" nzFor="dob"
          class="ppl-form-label">{{getAttributes('dob').label}}
          @if(getAttributes('dob').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control [nzSpan]="24" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('dob')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <!-- <nz-date-picker formControlName="dob" [id]="'dob' + sectionName" style="height: 32px;"
                  [nzFormat]="'MM/dd/yyyy'" [nzPlaceHolder]="getAttributes('dob').placeholder"
                  [nzDisabledDate]="disabledDate" [ngClass]="{'error': validationErrors['dob'] }" [nzDisabled]="formReadonly || (isReadonly() && getFormControlValue('dob'))"></nz-date-picker> -->
            <ppl-date-picker formControlName="dob" [id]="'dob' + sectionName"
              [showIcon]="true"
              [placeholder]="getAttributes('dob').placeholder"
              dateFormat="mm/dd/yy" [yearRange]="'1900:2050'"
              [iconDisplay]="'input'" inputId="icondisplay"
              [panelStyleClass]="'custom-calendar-panel'"
              [disableControl]="formReadonly || (isReadonly() && getFormControlValue('dob'))"
              [styleClass]="validationErrors['dob'] ? 'error' : ''"
              [maxDate]="yesterday">
            </ppl-date-picker>
          </div>
          @if (validationErrors['dob']) {
          <span class="pl-1 error-message">{{validationErrors['dob']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </div>
    }
    @if(isAttrAvailable('conservatorship')){
    <div nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSpan]="24" nzFor="conservatorship"
          class="ppl-form-label">{{getAttributes('conservatorship').label}}
          @if(getAttributes('conservatorship').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control [nzSpan]="24" class="ppl-form-control">
          <div nz-tooltip
            [nzTooltipTitle]="getAttributes('conservatorship')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <div class="ppl-select"
              [ngClass]="{'error': validationErrors['conservatorship'] }">
              <ppl-dropdown-select formControlName="conservatorship"
                id="conservatorship"
                [options]="conservatorshipTypes"
                [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                [placeholder]="getAttributes('conservatorship').placeholder"
                [disabled]="formReadonly">
              </ppl-dropdown-select>
            </div>
          </div>
          @if (validationErrors['conservatorship']) {
          <span class="pl-1 error-message">{{validationErrors['conservatorship']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </div>
    }
    @if(isAttrAvailable('gender')){
    <div nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSpan]="24" [nzFor]="getAccessibleInputId('gender')"
          class="ppl-form-label">{{getAttributes('gender').label}}
          @if(getAttributes('gender').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control [nzSpan]="24" class="ppl-form-control">
          <div nz-tooltip
            [nzTooltipTitle]="getAttributes('gender')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <div class="ppl-select"
              [ngClass]="{'error': validationErrors['gender'] }">
              <ppl-dropdown-select formControlName="gender"
                id="{{getAccessibleInputId('gender')}}" [options]="gender"
                [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                [disabled]="formReadonly">
              </ppl-dropdown-select>
            </div>
          </div>
          @if (validationErrors['gender']) {
          <span class="pl-1 error-message">{{validationErrors['gender']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </div>
    }

    @if(isAttrAvailable('isProvidingServices')){
    <div nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSpan]="24" nzFor="gender"
          class="ppl-form-label">{{getAttributes('isProvidingServices').label}}
          @if(getAttributes('isProvidingServices').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control [nzSpan]="24" class="ppl-form-control">
          <div nz-tooltip
            [nzTooltipTitle]="getAttributes('isProvidingServices')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <nz-radio-group formControlName="isProvidingServices"
              class="ppl-radio-group"
              [id]="'isProvidingServices' + sectionName"
              [ngClass]="{'error': validationErrors['isProvidingServices'] }">
              @for(opt of radioOptions; track $index){
              <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
              }
            </nz-radio-group>
          </div>
          @if (validationErrors['isProvidingServices']) {
          <span
            class="pl-1 error-message">{{validationErrors['isProvidingServices']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </div>
    }

    @if(isAttrAvailable('SSN')){
    <div nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSpan]="24" nzFor="SSN"
          class="ppl-form-label">{{getAttributes('SSN').label}}
          @if(isSsnMandatory()){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control [nzSpan]="24" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('SSN')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <nz-input-group [nzSuffix]="suffixTemplate"
              style="height: 32px; padding: 0px 11px;"
              [ngClass]="{'error': validationErrors['SSN'], 'input-group--readonly': (isReadonly() && getFormControlValue('SSN')) }">
              <input nz-input [type]="ssnVisible ? 'text' : 'password'"
                formControlName="SSN" autocomplete="off"
                (input)="limitDigits($event)" [id]="'SSN' + sectionName"
                placeholder="{{getAttributes('SSN').placeholder}}"
                [readonly]="formReadonly || (isReadonly() && getFormControlValue('SSN'))" />
            </nz-input-group>
          </div>
          <ng-template #suffixTemplate>
            <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
            <button [attr.aria-label]="ssnVisible ? 'Hide SSN' : 'Show SSN'"
              class="ssn-visible" nz-icon
              [nzType]="ssnVisible ? 'eye' : 'eye-invisible'"
              (click)="ssnVisible = !ssnVisible"></button>
          </ng-template>
          @if (validationErrors['SSN']) {
          <span class="pl-1 error-message">{{validationErrors['SSN']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </div>
    }

    @if(isAttrAvailable('ITIN')){
    <div nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSpan]="24" nzFor="ITIN"
          class="ppl-form-label">{{getAttributes('ITIN').label}}
          @if(isITINMandatory()){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control [nzSpan]="24" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('ITIN')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <nz-input-group [nzSuffix]="itinSuffixTemplate"
              style="height: 32px; padding: 0px 11px;"
              [ngClass]="{'error': validationErrors['ITIN'], 'input-group--readonly': (isReadonly() && getFormControlValue('ITIN')) }">
              <input nz-input [type]="itinVisible ? 'text' : 'password'"
                formControlName="ITIN" autocomplete="off"
                (input)="limitItinDigits($event)" [id]="'ITIN' + sectionName"
                placeholder="{{getAttributes('ITIN').placeholder}}"
                [readonly]="formReadonly || (isReadonly() && getFormControlValue('ITIN'))" />
            </nz-input-group>
          </div>
          <ng-template #itinSuffixTemplate>
            <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
            <button [attr.aria-label]="itinVisible ? 'Hide ITIN' : 'Show ITIN'"
              class="ssn-visible" nz-icon
              [nzType]="itinVisible ? 'eye' : 'eye-invisible'"
              (click)="itinVisible = !itinVisible"></button>
          </ng-template>
          @if (validationErrors['ITIN']) {
          <span class="pl-1 error-message">{{validationErrors['ITIN']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </div>
    }

    @if(isAttrAvailable('relationToParticipant')){
    <div nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSpan]="24"
          [nzFor]="getAccessibleInputId('relationToParticipant')"
          class="ppl-form-label">{{getAttributes('relationToParticipant').label}}
          @if(getAttributes('relationToParticipant').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control [nzSpan]="24" class="ppl-form-control" nz-tooltip
          nzTooltipTitle="{{getAttributes('relationToParticipant').tooltip}}"
          nzTooltipPlacement="topRight">
          <div class="ppl-select"
            [ngClass]="{'error': validationErrors['relationToParticipant'] }">
            <ppl-dropdown-select formControlName="relationToParticipant"
              id="{{getAccessibleInputId('relationToParticipant')}}"
              placeholder="Select relation to Participant"
              [options]="relationshipOptions" [optionLabel]="'lkpValueName'"
              [optionValue]="'lkpValueCode'"
              [disabled]="formReadonly">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['relationToParticipant']) {
          <span
            class="pl-1 error-message">{{validationErrors['relationToParticipant']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </div>
    }

    @if(isAttrAvailable('EIN')){
    <div nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSpan]="24" nzFor="EIN"
          class="ppl-form-label">{{getAttributes('EIN').label}}
          @if(isEinMandatory()){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control [nzSpan]="24" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('EIN')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <input nz-input formControlName="EIN" id="EIN"
              placeholder="{{getAttributes('EIN').placeholder}}"
              (input)="limitDigits($event, 'EIN')"
              [ngClass]="{'error': validationErrors['EIN'] }" />
          </div>
          @if (validationErrors['EIN']) {
          <span class="pl-1 error-message">{{validationErrors['EIN']}}</span>
          }

        </nz-form-control>
      </nz-form-item>

    </div>
    @if(sectionName === 'employer'){
    <div nz-col [nzSm]="18" [nzXs]="24" class="notes">
      <strong>Notes:</strong>
      <p>
        1. If EIN is lost/misplaced, then obtain your existing EIN using "<a>How
          to ask the IRS
          for a
          147c letter</a>".
      </p>
      <p>
        2. If EIN doesn't exist, PPL will obtain an EIN on your behalf after
        completion and
        submission
        of registration paperwork.
      </p>
    </div>
    }
    }

    @if(isAttrAvailable('NPI')){
    <div nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSpan]="24" nzFor="NPI"
          class="ppl-form-label">{{getAttributes('NPI').label}}
          @if(getAttributes('NPI').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control [nzSpan]="24" class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle]="getAttributes('NPI')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <input nz-input formControlName="NPI" [id]="'NPI'  + sectionName"
              placeholder="{{getAttributes('NPI').placeholder}}"
              [ngClass]="{'error': validationErrors['NPI'] }"
              [readonly]="formReadonly || (isReadonly() && getFormControlValue('NPI'))" />
          </div>
          @if (validationErrors['NPI']) {
          <span class="pl-1 error-message">{{validationErrors['NPI']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </div>
    }

    @if(isAttrAvailable('additionalDemographics')){
    <div nz-col [nzSm]="24" [nzXs]="24">
      <nz-form-label [nzSpan]="24" nzFor="additionalDemographics"
        class="ppl-form-label"
        style="margin:8px 0 24px 0;">{{getAttributes('additionalDemographics').label}}
        @if(getAttributes('additionalDemographics').mandatory === 'Y'){
        <span>*</span>
        }
      </nz-form-label>
      <nz-row>
        @if(isAttrAvailable('race')){
        <div nz-col nzFlex="1 1 auto" [nzXs]="24">
          <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
            <nz-form-label [nzSpan]="24" nzFor="race"
              class="ppl-form-label">{{getAttributes('race').label}}
              @if(getAttributes('race').mandatory === 'Y'){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control" nz-tooltip
              nzTooltipTitle="{{getAttributes('race').tooltip}}"
              nzTooltipPlacement="topRight">
              <div [ngClass]="{'error': validationErrors['race'] }">
                <ppl-dropdown-select formControlName="race"
                  [options]="raceOptions" [optionLabel]="'lkpValueName'"
                  [optionValue]="'lkpValueCode'" id="'race' + {{sectionName}}"
                  [disabled]="formReadonly">
                </ppl-dropdown-select>
              </div>
              @if (validationErrors['race']) {
              <span
                class="pl-1 error-message">{{validationErrors['race']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </div>
        }
        @if(isAttrAvailable('height')){
        <div nz-col nzFlex="1 1 auto" [nzXs]="24">
          <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
            <nz-form-label [nzSpan]="24" nzFor="height"
              class="ppl-form-label">{{getAttributes('height').label}}
              @if(getAttributes('height').mandatory === 'Y'){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('height')?.tooltip || ''"
                nzTooltipPlacement="topRight"
                class="height-input-container ppl-form-control">
                <nz-row [nzGutter]="16">
                  <nz-col [nzSm]="12" [nzXs]="24">
                    <input nz-input formControlName="heightFeet"
                      [id]="'heightFeet'  + sectionName" placeholder="Feet"
                      [ngClass]="{'error': validationErrors['heightFeet']}"
                      [readonly]="formReadonly" />
                  </nz-col>
                  <nz-col [nzSm]="12" [nzXs]="24">
                    <input nz-input formControlName="heightInches"
                      [id]="'heightInches'  + sectionName"
                      placeholder="Inches"
                      [ngClass]="{'error': validationErrors['heightInches']}"
                      [readonly]="formReadonly" />
                  </nz-col>
                </nz-row>
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>
        }
        @if(isAttrAvailable('weight')){
        <div nz-col nzFlex="1 1 auto" [nzXs]="24">
          <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
            <nz-form-label [nzSpan]="24" nzFor="weight" class="ppl-form-label">
              {{getAttributes('weight').label}}
              @if(getAttributes('weight').mandatory === 'Y'){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip
                [nzTooltipTitle]="getAttributes('weight')?.tooltip || ''"
                nzTooltipPlacement="topRight"
                class="weight-input-container ppl-form-control">
                <input nz-input formControlName="weight"
                  [id]="'weight'  + sectionName"
                  placeholder="{{getAttributes('weight').placeholder}}"
                  [ngClass]="{'error': validationErrors['weight']}"
                  [readonly]="formReadonly" />
                <!-- <span class="unit-label">Pounds</span> -->
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>
        }
        @if(isAttrAvailable('eyeColor')){
        <div nz-col nzFlex="1 1 auto" [nzXs]="24">
          <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
            <nz-form-label [nzSpan]="24" nzFor="eyeColor"
              class="ppl-form-label">{{getAttributes('eyeColor').label}}
              @if(getAttributes('eyeColor').mandatory === 'Y'){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control" nz-tooltip
              nzTooltipTitle="{{getAttributes('eyeColor').tooltip}}"
              nzTooltipPlacement="topRight">
              <div [ngClass]="{'error': validationErrors['eyeColor'] }">
                <ppl-dropdown-select formControlName="eyeColor"
                  id="'eyeColor'  + {{sectionName}}" [options]="eyeColors"
                  [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                  [disabled]="formReadonly">
                </ppl-dropdown-select>
              </div>
              @if (validationErrors['eyeColor']) {
              <span
                class="pl-1 error-message">{{validationErrors['eyeColor']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </div>
        }
      </nz-row>
      <nz-row>
        @if(isAttrAvailable('hairColor')){
        <div nz-col nzFlex="1 1 auto" [nzXs]="24">
          <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
            <nz-form-label [nzSpan]="24" nzFor="hairColor"
              class="ppl-form-label">{{getAttributes('hairColor').label}}
              @if(getAttributes('hairColor').mandatory === 'Y'){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control" nz-tooltip
              nzTooltipTitle="{{getAttributes('hairColor').tooltip}}"
              nzTooltipPlacement="topRight">
              <div [ngClass]="{'error': validationErrors['hairColor'] }">
                <ppl-dropdown-select formControlName="hairColor"
                  id="'hairColor'  + {{sectionName}}"
                  [options]="hairColors" [optionLabel]="'lkpValueName'"
                  [optionValue]="'lkpValueCode'"
                  [disabled]="formReadonly">
                </ppl-dropdown-select>
              </div>
              @if (validationErrors['hairColor']) {
              <span
                class="pl-1 error-message">{{validationErrors['hairColor']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </div>
        }
        @if(isAttrAvailable('birthPlace')){
        <div nz-col nzFlex="1 1 auto" [nzXs]="24">
          <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
            <nz-form-label [nzSpan]="24" nzFor="birthPlace"
              class="ppl-form-label">{{getAttributes('birthPlace').label}}
              @if(getAttributes('birthPlace').mandatory === 'Y'){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip [nzTooltipTitle] nzTooltipPlacement="topRight">
                <input nz-input formControlName="birthCity"
                  [id]="'birthCity'  + sectionName" placeholder="City"
                  [readonly]="formReadonly" />
              </div>
            </nz-form-control>
            <nz-form-control [nzSpan]="24" class="ppl-form-control"
              style="margin: 0px 4px;">
              <div nz-tooltip [nzTooltipTitle] nzTooltipPlacement="topRight">
                <input nz-input formControlName="birthState"
                  [id]="'state'  + sectionName" placeholder="State"
                  [readonly]="formReadonly" />
              </div>
            </nz-form-control>
            <nz-form-control [nzSpan]="24" class="ppl-form-control">
              <div nz-tooltip [nzTooltipTitle] nzTooltipPlacement="topRight">
                <input nz-input formControlName="birthCountry"
                  [id]="'country'  + sectionName" placeholder="Country"
                  [readonly]="formReadonly" />
              </div>
            </nz-form-control>
          </nz-form-item>
        </div>
        }
      </nz-row>
    </div>
    }
  </nz-row>
  <nz-row>
    @if(isAttrAvailable('email') || isAttrAvailable('mobile') ||
    isAttrAvailable('altPhone')){
    <!-- <nz-divider class="divider"></nz-divider> -->
    <nz-form-item class="ppl-form-item">
      <nz-form-label [nzSpan]="24" nzFor="email"
        style="margin-bottom: 8px !important" class="ppl-form-label">Please
        provide a value for at least one of the following contact methods:
        <span>*</span>
      </nz-form-label>
      @if(isAttrAvailable('email')){
      <nz-form-control class="ppl-form-control">
        <input nz-input nz-tooltip
          nzTooltipTitle="{{getAttributes('email').tooltip}}"
          nzTooltipPlacement="topRight"
          formControlName="email" [id]="'email'  + sectionName"
          [ngClass]="{'error': validationErrors['email'] }"
          placeholder="{{getAttributes('email').placeholder}}"
          [readonly]="formReadonly" />
        @if (validationErrors['email']) {
        <span class="pl-1 error-message">{{validationErrors['email']}}</span>
        }
      </nz-form-control>
      }
      @if(isAttrAvailable('mobile')){
      <nz-form-control class="ppl-form-control">
        <input nz-tooltip nzTooltipTitle="{{getAttributes('mobile').tooltip}}"
          nzTooltipPlacement="topRight" nz-input
          [id]="'mobile'  + sectionName" formControlName="mobile"
          [ngClass]="{'error': validationErrors['mobile'] }"
          placeholder="{{getAttributes('mobile').placeholder}}"
          [readonly]="formReadonly"
          (input)="limitMobileDigits($event)" />
        @if (validationErrors['mobile']) {
        <span class="pl-1 error-message">{{validationErrors['mobile']}}</span>
        }
      </nz-form-control>
      }
      @if(isAttrAvailable('altPhone')){
      <nz-form-control class="ppl-form-control">
        <input nz-tooltip nzTooltipTitle="{{getAttributes('altPhone').tooltip}}"
          nzTooltipPlacement="topRight" nz-input
          formControlName="altPhone"
          [ngClass]="{'error': validationErrors['altPhone'] }"
          [id]="'altPhone'  + sectionName"
          placeholder="{{getAttributes('altPhone').placeholder}}"
          [readonly]="formReadonly" (input)="limitAltPhoneDigits($event)" />
        @if (validationErrors['altPhone']) {
        <span class="pl-1 error-message">{{validationErrors['altPhone']}}</span>
        }
      </nz-form-control>
      }
    </nz-form-item>
    <!-- <nz-divider class="divider"></nz-divider> -->
    }
    <!-- @if(isAttrAvailable('email') && !isAttrAvailable('mobile')){
        <nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
            <nz-form-label [nzSpan]="24" nzFor="email" [ngStyle]="{ 'margin-bottom':'0' }"
              class="ppl-form-label">{{getAttributes('email').label}}
              @if(getAttributes('email').mandatory === 'Y'){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input nz-tooltip nzTooltipTitle="{{getAttributes('email').tooltip}}" nzTooltipPlacement="topRight"
                formControlName="email" [id]="'email'  + sectionName" [ngClass]="{'error': validationErrors['email'] }"
                placeholder="{{getAttributes('email').placeholder}}" [readonly]="formReadonly" />
              @if (validationErrors['email']) {
              <span class="pl-1 error-message">{{validationErrors['email']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        } -->
    <!-- @if(isAttrAvailable('mobile') && !isAttrAvailable('email')){

          <nz-col [nzSm]="6" [nzXs]="24">
            <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
              <nz-form-label [nzSpan]="24" nzFor="mobile" class="ppl-form-label"
                [ngStyle]="{ 'margin-bottom':'0' }">{{getAttributes('mobile').label}}
                @if(getAttributes('mobile').mandatory === 'Y'){
                <span>*</span>
                }
              </nz-form-label>
              <nz-form-control [nzSpan]="24">
                <input nz-tooltip nzTooltipTitle="{{getAttributes('mobile').tooltip}}" nzTooltipPlacement="topRight"
                  nz-input [id]="'mobile'  + sectionName" formControlName="mobile"
                  [ngClass]="{'error': validationErrors['mobile'] }"
                  placeholder="{{getAttributes('mobile').placeholder}}" [readonly]="formReadonly" (input)="limitMobileDigits($event)" />
                @if (validationErrors['mobile']) {
                <span class="pl-1 error-message">{{validationErrors['mobile']}}</span>
                }
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          }
        @if(isAttrAvailable('altPhone')){
        <nz-col [nzSm]="6" [nzXs]="24">
          <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
            <nz-form-label [nzSpan]="24" nzFor="altPhone" [ngStyle]="{ 'margin-bottom':'0' }"
              class="ppl-form-label">{{getAttributes('altPhone').label}}
              @if(getAttributes('altPhone').mandatory === 'Y'){
              <span>*</span>
              }
            </nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-tooltip nzTooltipTitle="{{getAttributes('altPhone').tooltip}}" nzTooltipPlacement="topRight"
                nz-input formControlName="altPhone" [ngClass]="{'error': validationErrors['altPhone'] }"
                [id]="'altPhone'  + sectionName" placeholder="{{getAttributes('altPhone').placeholder}}" [readonly]="formReadonly" (input)="limitAltPhoneDigits($event)" />
              @if (validationErrors['altPhone']) {
              <span class="pl-1 error-message">{{validationErrors['altPhone']}}</span>
              }
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        } -->

  </nz-row>

  @if(isAttrAvailable('permanentAddress')){
  <nz-form-item class="ppl-form-item">
    <div class="address-section">
      <nz-form-control class="ppl-form-control address-control">
        <ppl-association-details-address
          [addressForm]="getFormGroup('permanentAddress')" [is_permanent]="true"
          [statesList]="statesList" [validationErrors]="permanentAddressErrors"
          [formReadonly]="formReadonly || isReadonly()"></ppl-association-details-address>
      </nz-form-control>
    </div>
  </nz-form-item>
  }

  <nz-row>
    @if(isAttrAvailable('yearsInState')){
    <nz-col [nzSm]="12" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="24" [nzXs]="24" nzFor="yearsInState"
          class="ppl-form-label">{{getAttributes('yearsInState').label}}
          @if(getAttributes('yearsInState').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control [nzSm]="12" class="ppl-form-control">
          <input nz-input nz-tooltip
            nzTooltipTitle="{{getAttributes('yearsInState').tooltip}}"
            nzTooltipPlacement="topRight" formControlName="yearsInState"
            [id]="'yearsInState'  + sectionName"
            [ngClass]="{'error': validationErrors['yearsInState'] }"
            placeholder="{{getAttributes('yearsInState').placeholder}}"
            [readonly]="formReadonly" />
          @if (validationErrors['yearsInState']) {
          <span
            class="pl-1 error-message">{{validationErrors['yearsInState']}}</span>
          }
          <div class="notes">
            <p>
              This response may require additional background checks during
              enrolment.
            </p>

          </div>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    }
  </nz-row>
  <nz-row [nzGutter]="16">
    @if(isAttrAvailable('emergencyContact')){
    <nz-col [nzSm]="24" [nzXs]="24">
      <nz-form-label [nzSm]="24" [nzXs]="24" nzFor="emergencyContact"
        class="ppl-form-label pl-3">{{getAttributes('emergencyContact').label}}
        @if(getAttributes('emergencyContact').mandatory === 'Y'){
        <span>*</span>
        }
      </nz-form-label>
    </nz-col>
    <nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-control class="ppl-form-control pl-3">
          <div nz-tooltip [nzTooltipTitle] nzTooltipPlacement="topRight">
            <input nz-input formControlName="emergencyContactFirstName"
              [id]="'emergencyContactFirstName'  + sectionName"
              placeholder="First Name" [readonly]="formReadonly"
              maxlength="20" />
          </div>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    <nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle] nzTooltipPlacement="topRight">
            <input nz-input formControlName="emergencyContactLastName"
              [id]="'emergencyContactLastName'  + sectionName"
              placeholder="Last Name" class="reduced-width-inputs"
              [readonly]="formReadonly" maxlength="20" />
          </div>
        </nz-form-control>
      </nz-form-item>
    </nz-col>

    <nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip [nzTooltipTitle] nzTooltipPlacement="topRight">
            <input nz-input formControlName="emergencyContactPhone"
              [id]="'emergencyContactPhone'  + sectionName"
              placeholder="Contact Number" class="reduced-width-inputs"
              [readonly]="formReadonly" />
          </div>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    }
  </nz-row>
  <nz-row class="ppl-new-form-control" [nzGutter]="16">
    @if(isAttrAvailable('registerPref')){
    <nz-form-item class="ppl-form-item" style="margin-bottom: 8px;">
      <nz-form-label [nzSm]="24" [nzXs]="24"
        [nzFor]="getAccessibleInputId('registerPref')"
        class="ppl-form-label">{{getAttributes('registerPref').label}}
        @if(getAttributes('registerPref').mandatory === 'Y'){
        <span>*</span>
        }
      </nz-form-label>
      <nz-col [nzSm]="8" [nzXs]="24">
        <nz-form-control class="ppl-form-control" nz-tooltip
          nzTooltipTitle="{{getAttributes('registerPref').tooltip}}"
          nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['registerPref'] }">
            <ppl-dropdown-select formControlName="registerPref"
              [disabled]="formReadonly"
              [options]="participantRegisterMode" [optionLabel]="'lkpValueName'"
              [optionValue]="'lkpValueCode'"
              id="{{getAccessibleInputId('registerPref')}}">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['registerPref']) {
          <span
            class="pl-1 error-message">{{validationErrors['registerPref']}}</span>
          }
        </nz-form-control>
      </nz-col>
    </nz-form-item>
    }
  </nz-row>

  @if(isAttrAvailable('nonProfitStatus')){
  <nz-form-item class="ppl-form-item">
    <nz-form-label [nzSm]="9" [nzXs]="24" nzFor="nonProfitStatus"
      class="ppl-form-label">{{getAttributes('nonProfitStatus').label}}
      @if(getAttributes('nonProfitStatus').mandatory === 'Y'){
      <span>*</span>
      }</nz-form-label>
  </nz-form-item>
  <nz-row>
    <nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="24" [nzXs]="24" nzFor="taxExempt"
          class="ppl-form-label">{{getAttributes('taxExempt').label}}
          @if(getAttributes('taxExempt').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div [ngClass]="{'error': validationErrors['taxExempt'] }">
            <ppl-dropdown-select formControlName="taxExempt"
              placeholder="{{getAttributes('taxExempt').placeholder}}"
              [disabled]="formReadonly" [options]="taxExemptOptions"
              [optionLabel]="'lkpValueName'"
              [optionValue]="'lkpValueCode'">
            </ppl-dropdown-select>
          </div>
          @if (validationErrors['taxExempt']) {
          <span
            class="pl-1 error-message">{{validationErrors['taxExempt']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    <nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="24" [nzXs]="24"
          nzFor="nprftDocumentationReceived"
          class="ppl-form-label">{{getAttributes('nprftDocumentationReceived').label}}
          @if(getAttributes('nprftDocumentationReceived').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div style="width:100%; margin-bottom: 16px"
            [ngClass]="{'error': validationErrors['nprftDocumentationReceived'] }">
            <ppl-dropdown-select
              placeholder="{{getAttributes('nprftDocumentationReceived').placeholder}}"
              id="nprftDocumentationReceived"
              formControlName="nprftDocumentationReceived"
              [disabled]="formReadonly"
              [options]="nprftDocumentationReceivedOptions"
              [optionLabel]="'label'"
              [optionValue]="'value'"></ppl-dropdown-select>
          </div>
          @if (validationErrors['nprftDocumentationReceived']) {
          <span
            class="pl-1 error-message">{{validationErrors['nprftDocumentationReceived']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </nz-col>
  </nz-row>
  }

  <nz-row>
    @if(isAttrAvailable('profLicences')){
    <nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="24" [nzXs]="24" nzFor="profLicences"
          class="ppl-form-label">{{getAttributes('profLicences').label}}
          @if(getAttributes('profLicences').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div nz-tooltip
            [nzTooltipTitle]="getAttributes('profLicences')?.tooltip || ''"
            nzTooltipPlacement="topRight">
            <div [ngClass]="{'error': validationErrors['profLicences'] }">
              <ppl-multiselect formControlName="profLicences"
                id="'profLicences'  + sectionName" [options]="licences"
                style="width:100%; margin-bottom: 16px" [showClear]="true"
                placeholder="{{getAttributes('profLicences').placeholder}}"
                [optionLabel]="'lkpValueName'"
                [optionValue]="'lkpValueCode'" [disabled]="formReadonly"
                [maxTagCount]="4"
                style="width:100%; margin-bottom: 16px">
              </ppl-multiselect>
            </div>
          </div>
          @if (validationErrors['profLicences']) {
          <span
            class="pl-1 error-message">{{validationErrors['profLicences']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    }

    @if(isAttrAvailable('servicesRendered')){
    <nz-col [nzSm]="6" [nzXs]="24">
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="24" [nzXs]="24" nzFor="servicesRendered"
          class="ppl-form-label">{{getAttributes('servicesRendered').label}}
          @if(getAttributes('servicesRendered').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <div [ngClass]="{'error': validationErrors['servicesRendered'] }">
            <ppl-multiselect formControlName="servicesRendered"
              id="'servicesRendered'  + sectionName"
              [options]="services" style="width:100%; margin-bottom: 16px"
              [showClear]="true"
              placeholder="{{getAttributes('servicesRendered').placeholder}}"
              [optionLabel]="'lkpValueName'"
              [optionValue]="'lkpValueCode'" [disabled]="formReadonly"
              [maxTagCount]="4"
              style="width:100%; margin-bottom: 16px">
            </ppl-multiselect>
          </div>
          @if (validationErrors['servicesRendered']) {
          <span
            class="pl-1 error-message">{{validationErrors['servicesRendered']}}</span>
          }
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    }
  </nz-row>
  <nz-row>
    @if(isAttrAvailable('consent')){
    <nz-col [nzSm]="18" [nzXs]="24">
      <ul class="bullet-list">
        <li class="bullet-item"><b>A person receiving services in the California
            Self-Determination Program (Participant) or their legal
            guardian:</b></li>
        <ul class="bullet-list">
          <li class="bullet-item">Has the right to choose an Authorized
            Representative (AR).</li>
          <li class="bullet-item">May also appoint a co-AR or backup AR.</li>
        </ul>
        <li class="bullet-item"><b>If you are a Participant, or the legal
            guardian of a Participant, and want to appoint an AR:</b></li>
        <ul class="bullet-list">
          <li class="bullet-item">Complete this Authorized Representative
            Appointment Form (Form).</li>
          <li class="bullet-item">Also, complete this Form for every AR
            appointed.</li>
        </ul>
        <li class="bullet-item"><b>The purpose of this Form is:</b></li>
        <ul class="bullet-list">
          <li class="bullet-item">To tell Public Partnerships LLC (PPL) that the
            named AR was appointed,</li>
          <li class="bullet-item">To authorize PPL to work with the appointed
            AR, and</li>
          <li class="bullet-item">To give PPL required information about the
            AR.</li>
        </ul>
        <li class="bullet-item"><b>Who can be an AR:</b></li>
        <ul class="bullet-list">
          <li class="bullet-item">An AR must be at least 18 years old.</li>
          <li class="bullet-item">An AR may be a family member, friend, or
            court-appointed conservator.</li>
          <li class="bullet-item">An AR cannot be a paid Worker.</li>
        </ul>
        <li class="bullet-item"><b>The role of the AR:</b></li>
        <ul class="bullet-list">
          <li class="bullet-item">The role of the AR is to help the Employer
            with their Employer duties.</li>
          <li class="bullet-item">The California Self-Determination Program
            (Program) allows the AR to speak to PPL about:</li>
          <ul class="bullet-list">
            <li>The Participant,</li>
            <li>The Employer, or</li>
            <li>The Workers.</li>
          </ul>
          <li class="bullet-item">Help the Employer with any Employer duties.
            This includes Employer duties such as:</li>
          <ul class="bullet-list">
            <li class="bullet-item">Finding Workers.</li>
            <li class="bullet-item">Training Workers to meet the needs of the
              Participant. This includes confirming that the Worker completed
              needed training.</li>
            <li class="bullet-item">Completing forms which are used to set wages
              for Workers.</li>
            <li class="bullet-item">Scheduling when services will be provided to
              the Participant.</li>
            <li class="bullet-item">Supervising the Worker's job
              performance.</li>
            <li class="bullet-item">Managing the Worker.</li>
            <li class="bullet-item">Reviewing and approving the Worker's time
              sheets. This includes daily time entries on timesheets.</li>
            <li class="bullet-item">If needed, dismissing (firing) Workers.</li>
            <li class="bullet-item">Ensuring spending is within the approved
              individual budget.</li>
            <li class="bullet-item">Following the Individual Program Plan (IPP)
              and Person-Centered Plan.</li>
            <li class="bullet-item">Managing service authorizations.</li>
            <li class="bullet-item">Coordinating with the Independent
              Facilitator and Regional Center as needed.</li>
          </ul>
        </ul>
      </ul>
      <nz-form-item class="ppl-form-item">
        <nz-form-control class="ppl-form-control">
          <input nz-input type="checkbox" class="checkbox"
            formControlName="consent" />
          <span style="margin-left: 8px; font-weight: 600;">I have read and
            understand the above rules.</span>
          <p>
            <span *ngIf="validationErrors['consent']"
              class="pl-1 error-message">
              {{validationErrors['consent']}}
            </span>
          </p>
        </nz-form-control>
      </nz-form-item>
    </nz-col>
    }
  </nz-row>
  }
</form>
}
